
import { Container, Modal, ModalChildren, ModalTitle } from './style';

interface BaseModalProps {
  children: any;
  toggleModal: any;
  setToggleModal:any;
  title:string
  onConfirm?: () => void;
  onCancel?: () => void;
  footer: any;
}

export default function BaseModal({children, toggleModal, setToggleModal, title, onConfirm, footer, onCancel}:BaseModalProps){

  return (
    <Container>
      <Modal onCancel={onCancel} footer={footer} destroyOnClose={true} title={""} open={toggleModal} onOk={onConfirm}>
        <ModalTitle>{title}</ModalTitle>
        <ModalChildren>{children}</ModalChildren>
      </Modal>
    </Container>
  );
};

